import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { BEST_POSTS } from "../keys";

const useBestPosts = (sorting, params) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }
  return useQuery({
    queryKey: [
      BEST_POSTS,
      tenant.id,
      `${sorting.order ? "-" : ""}${sorting.value}`,
      startDate,
      endDate,
      params,
    ],
    queryFn: () =>
      ApiService.getPerformingSocialMediaPosts(
        since,
        until,
        sorting.value,
        sorting.order ? "asc" : "desc",
        params
      ),
    select: (res) => {
      const { facebook, instagram, earned } = res.data.posts;

      // Concatenate all posts and sort them
      const allPosts = facebook
        .concat(earned)
        .concat(instagram)
        .sort((a, b) => {
          const diff = sorting.order
            ? a[sorting.value] - b[sorting.value]
            : b[sorting.value] - a[sorting.value];
          // Tiebreak on id so equal metrics keep a stable order between fetches
          return diff !== 0 ? diff : (b.id || 0) - (a.id || 0);
        });

      // Limit to 12 posts after sorting
      const limitedPosts = allPosts.slice(0, 12);

      return {
        posts: limitedPosts,
        socials: res.data.socials,
      };
    },
    enabled,
    placeholderData: {
      posts: { facebook: [], instagram: [] },
      socials: [{ facebook: [], instagram: [] }],
    },
  });
};
export default useBestPosts;
